import { jsonBody, requestJson } from "../http/httpClient";
import { readObject, readString } from "../http/jsonDecoding";

/**
 * "Save as Workflow" (FR-WF-3, `docs/components/reviews.md` R-8): picked entries of a
 * Thread's path become a Workflow, proposed as one change set for review. The answer names
 * the change set, so the web app can open its review.
 */

export interface WorkflowSavePick {
  /** A turn request or a human step entry on the path. */
  readonly entry: number;
  readonly key: string | null;
  readonly start: "automatic" | "on_request";
}

export interface WorkflowSave {
  readonly name: string;
  readonly description: string;
  readonly savedAt: number;
  readonly steps: readonly WorkflowSavePick[];
}

/** Propose the Workflow; returns the ID of the change set to review. */
export function saveAsWorkflow(threadId: string, save: WorkflowSave): Promise<string> {
  return requestJson({
    method: "POST",
    path: `/threads/${encodeURIComponent(threadId)}/workflow-saves`,
    body: jsonBody({
      name: save.name,
      description: save.description,
      saved_at: save.savedAt,
      steps: save.steps.map((step) => ({ entry: step.entry, key: step.key, start: step.start })),
    }),
    decodeResponse: (body) => {
      const changeSet = readObject(readObject(readObject(body, "saved Workflow")["change_set"], "change set view")["change_set"], "change set");
      return readString(changeSet, "change_set_id");
    },
  });
}
